/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Suspense } from 'react';

import { jsx } from '@atlaskit/css';

const LazyRovoLoadingGif = React.lazy(
	() => import(/* webpackChunkName: "@atlaskit-internal_rovo-loading-gif" */ './main'),
);

export const LazyAnimatedRovoIcon = React.memo(
	({
		alt = '',
		testId = '',
		width = '',
		height = '',
	}: {
		alt?: string;
		testId?: string;
		width?: string;
		height?: string;
	}): JSX.Element => {
		return (
			<Suspense>
				<LazyRovoLoadingGif alt={alt} testId={testId} width={width} height={height} />
			</Suspense>
		);
	},
);
